import { Checkbox } from '@policygenius/mortar';
import React from 'react';

import { FieldRenderProps } from 'forms/types';

import { CheckboxFieldProps } from './types';

type Props = CheckboxFieldProps & FieldRenderProps<boolean>;

const CheckboxField: React.FC<Props> = ({ input, meta: _meta, onChange, ...props }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newVal = e.target.checked;

    if (onChange) {
      onChange(newVal);
    }

    input.onChange(newVal);
  };

  return <Checkbox {...input} {...props} onChange={handleChange} value="" />;
};

export default CheckboxField;
